module.exports = __webpack_public_path__ + "img/sidenav-item-history.7dce9aab.svg";